import React from "react";
import "./ui.css";
import { AppColors } from "../utils/global-constants";
const CustomInput = ({
  placeholder,
  password,
  label,
  onChange,
  value,
  icon,
}) => {
  return (
    <div className="custom-input-container">
      <p>{label}</p>
      <div className="custom-input-container-inner">
        {icon ? (
          <ion-icon
            style={{
              fontSize: "24px",
              marginRight: 10,
              marginTop: 4,
              color: AppColors.white,
            }}
            name={icon}
          ></ion-icon>
        ) : null}
        <input
          type={password ? "password" : "text"}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
        />
      </div>
    </div>
  );
};

export default CustomInput;
